export default {
      id: "icon--contact-us-usage",
      viewBox: "0 0 22 32",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--contact-us-usage",
      toString: function () {
        return this.url;
      }
    }